import { render, staticRenderFns } from "./AreYouSureDialog.vue?vue&type=template&id=9bb96c62&scoped=true&"
import script from "./AreYouSureDialog.vue?vue&type=script&lang=js&"
export * from "./AreYouSureDialog.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSureDialog.vue?vue&type=style&index=0&id=9bb96c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb96c62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
